import React,{useEffect,useState} from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import swal from "sweetalert";
//Images
import mapSvg from "../../../images/svg/map.svg";

import { Dropdown } from "react-bootstrap";

import DoughnutChart from "../charts/Chartjs/donught";
import { getPatients } from "../../../store/selectors/PatientSelector";
import { connect } from 'react-redux';
import { DateTimePicker } from "@material-ui/pickers";
import { getClientConsultationsAction } from "../../../store/actions/ConsultationActions";
import PerfectScrollbar from "react-perfect-scrollbar";
import {format} from 'date-fns';
import { currentUser } from "../../../store/selectors/CurrentUserSelector";
import { PrestationsTab } from "./PrestationsTab";
import { Message } from 'primereact/message';
import { useTranslation } from "react-i18next";
import avatarDefault from "../../../images/avatar-default.jpg";
import './PatientDetails.css'


const PatientDetails = (props) => {
   const dispatch = useDispatch();
   const [patient, setPatient] = useState(null);
   const { t } = useTranslation();

   useEffect(() => {
      dispatch(getClientConsultationsAction(props.patients.idClient));
      if(props.patients && props.patients.isIssue){
         swal('Oops', props.patients.issueMessage);
      }
   }, []);
   
   const p = props.patients?.clientContrat?.length > 0 ? props.patients.clientContrat[0] : []
   const date = new Date();
   const dateExpireContrat = new Date(p["Date Echéance"]);
   if(dateExpireContrat < date.getDate()){
      swal('Oops', "Contrat du patient expiré", "infos");
   }  
   const img = props.patients.img

   const tarifsData = () => {
         let res = [];
         return res;
   }

   const dayHospiString = (consultation) => {
       let str = "";
       let diff = Math.abs(new Date() - new Date(consultation.dateDebutHospi));
       let diff2 = Math.abs(new Date(consultation.dateFinHospi) - new Date());

       let days = Math.ceil(diff / (1000*60*60*24));
       let remainDays = Math.ceil(diff2 / (1000*60*60*24));
       
       if(days <= 0){
           str = "1er jour d'hospitalisation, ";
       }else{
           str = days + "e jour d'hospitalisation, ";
       }

       if(remainDays < 0){
           str += "patient sorti d'hospitalisation.";
       }else if(remainDays === 0){
           str += "sortie prévue aujourd'hui.";
       }else{
           str += "sortie prévue dans "+(remainDays - 1)+" jour(s)"
       }

       return str;

   }

   const canDo = (menuCode, actionCode) => {
      let theMenu = props.currentUser.menus?.find(menu => menu.code === menuCode);
      if(!theMenu){
        return false;
      }else{
        return theMenu.actionMenus?.filter(action => action.code === actionCode).length > 0;
      }
    }
  
   const hasMenu = (menuCode) => {
        return props.currentUser.menus?.filter(menu => menu.code === menuCode).length > 0;
    }

   const isContractValid = () => {
      if(props.patients.contrat?.police?.dateExpiration) {
         let expDate = new Date(props.patients.contrat?.police?.dateExpiration);
         let today = new Date();
         if(expDate && expDate > today) {
            return true;
         }
      }
      return false;
   }

   return (
      <>

         {!isContractValid() && <Message
               style={{
                  border: 'solid #696cff',
                  borderWidth: '0 0 0 6px',
                  color: '#696cff'
               }}
               className="border-danger w-full justify-content-start mb-3"
               severity="error"
               content={(
                  <div className="flex align-items-center text-danger">
                      <i className="fa fa-warning"></i>
                      <div className="ml-2">{t('patient.expired-policy')}</div>
                  </div>
              )}
         />}
         {props.patients.issueMessage && <Message
               style={{
                  border: 'solid #696cff',
                  borderWidth: '0 0 0 6px',
                  color: '#696cff'
               }}
               className={props.patients.isIssue ? "border-danger w-full justify-content-start mb-3" : "border-info w-full justify-content-start mb-3"}
               severity={props.patients.isIssue ? "danger" : "info"}
               content={(
                  <div className={props.patients.isIssue ? "flex align-items-center text-danger" : "flex align-items-center text-info"}>
                      <i className="fa fa-warning"></i>
                      <div className="ml-2">{props.patients.issueMessage}</div>
                  </div>
              )}
         />}
        
         <div className="d-md-flex d-block mb-3 align-items-center justify-content-between">
            <div className="d-flex flex-column">
               <div className="widget-timeline-icon py-3 py-md-2 px-1 overflow-auto">
                     <ul className="timeline">
                        <li>
                           <div className="icon bg-warning" />
                           <Link
                                 className="timeline-panel text-muted"
                                 to="#"
                           >
                                 <h4 className="mb-2 mt-0 text-warning fs-16 font-w600">
                                 {t('patient.in-consultation')}
                                 </h4>
                                 {props.consultations[0]?.openDate && <p className="fs-14 mb-0 ">
                                    {format(new Date(props.consultations[0]?.openDate), 'dd/MM/yyyy hh:mm')}
                                 </p>}
                           </Link>
                        </li>
                        {props.consultations[0]?.isHospi && 
                        <>
                           <li className="border-info">
                                 <div className="icon bg-info" />
                                 <Link
                                    className="timeline-panel text-muted"
                                    to="#"
                                 >
                                    <h4 className="mb-2 mt-0 text-info fs-16 font-w600">
                                    {t('patient.in-hospitalisation')}
                                    </h4>
                                    {props.consultations[0]?.dateDebutHospi && <p className="fs-14 mb-0 ">
                                       {format(new Date(props.consultations[0]?.dateDebutHospi), 'dd/MM/yyyy hh:mm')}
                                    </p>}
                                 </Link>
                           </li>
                           <li>
                                 <div className="icon bg-primary" />
                                 <Link
                                    className="timeline-panel text-muted"
                                    to="#"
                                 >
                                    <h4 className="mb-2 text-primary mt-0 fs-16 font-w600">
                                    {t('patient.out-on')}
                                    </h4>
                                    {props.consultations[0]?.dateFinHospi && <p className="fs-14 mb-0 ">
                                       {format(new Date(props.consultations[0]?.dateFinHospi), 'dd/MM/yyyy hh:mm')}
                                    </p>}
                                 </Link>
                           </li>
                        </>
                        }
                     </ul>
               </div>
               {props.consultations[0]?.isHospi === true && props.consultations[0]?.isclose === false && <div className="my-2">
                     <span className="text-info font-weight-bold">{dayHospiString(props.consultations[0])}</span>
               </div>}
            </div>
            <div>
               {(hasMenu('MENCONSULT') && canDo('MENCONSULT', 'ACREQCONSULT')) && isContractValid() && !props.patients.isIssue && <Link
                  to={"/consultation-request/"+props.patients.idClient+"/"+props.patients.firstName+" "+props.patients.lastName}
                  className="btn btn-primary btn-rounded wspace-no"
               >
                  <i className="las scale5 la-pencil-alt mr-2" /> {t('patient.ask-consultation')}
               </Link>}
               {(hasMenu('MENCONSULT') && canDo('MENCONSULT', 'ACVIEWMEDFOLD')) && <Link
                  to={"/dossier-medical/"+props.patients.idClient}
                  className="btn btn-success btn-rounded wspace-no mx-2"
               >
                  <i className="las scale5 la-folder-plus mr-2" /> {t('patient.medical-folder')}
               </Link>}
            </div>
         </div>
         {!props.patients.from_card && <div className="row">
            <div className="col-xl-6 col-xxl-8">
               <div className="card">
                  <div className="card-body">
                     <div className="media d-sm-flex d-block text-center text-sm-left pb-4 mb-4 border-bottom">
                        <img
                           alt=""
                           className="rounded mr-sm-4 mr-0"
                           width={130}
                           src={props.patients.clientPhoto}
                        />
                        <div className="media-body align-items-center">
                           <div className="d-sm-flex d-block justify-content-between my-3 my-sm-0">
                              <div>
                                 <h3 className="fs-22 text-black font-w600 mb-0">
                                    {props.patients.firstName+" "+props.patients.lastName}
                                 </h3>
                                 {props.patients && props.patients.birthdate && <p className="mb-2 mb-sm-2">
                                    {t('common.born-on')} {format(new Date(props.patients.birthdate), 'dd/MM/yyyy')}
                                 </p>}
                              </div>
                           </div>
                           
                           <div className="d-sm-flex d-block justify-content-start my-3 my-sm-0">
                              <Link
                                 to="#"
                                 className="btn bgl-primary btn-rounded text-black mb-2 mr-2"
                              >
                                 <svg
                                    className="mr-2 scale5"
                                    width={14}
                                    height={14}
                                    viewBox="0 0 26 26"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                 > { props.patients.sexe == "M" ?
                                    <path
                                       d="M18 0.500061V3.00006H21.25L16.625 7.62506C15 6.25006 12.875 5.50006 10.5 5.50006C5 5.50006 0.5 10.0001 0.5 15.5001C0.5 21.0001 5 25.5001 10.5 25.5001C16 25.5001 20.5 21.0001 20.5 15.5001C20.5 13.1251 19.75 11.0001 18.375 9.37506L23 4.75006V8.00006H25.5V0.500061H18ZM10.5 23.0001C6.375 23.0001 3 19.6251 3 15.5001C3 11.3751 6.375 8.00006 10.5 8.00006C14.625 8.00006 18 11.3751 18 15.5001C18 19.6251 14.625 23.0001 10.5 23.0001Z"
                                       fill="#2BC155"
                                    /> :
                                    <path d="M21 9c0-4.97-4.03-9-9-9s-9 4.03-9 9c0 4.632 3.501 8.443 8 8.941v2.059h-3v2h3v2h2v-2h3v-2h-3v-2.059c4.499-.498 8-4.309 8-8.941zm-16 0c0-3.86 3.14-7 7-7s7 3.14 7 7-3.14 7-7 7-7-3.14-7-7z"
                                    fill="#2BC155" 
                                    />}
                                 </svg>
                                 {props.patients.sexe === 'M' ? 'Masculin' : 'Feminin'}
                              </Link>
                              {props.patients.profession && <Link
                                 to="#"
                                 className="btn bgl-primary btn-rounded text-black mb-2 mr-2"
                              >
                                 <svg fill="#229743" viewBox="0 0 28 28" width={24} height={24} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" ><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M352.9,53.4H441.6c33.601,0,61.601,24,68,55.7H560.2C553.4,49.7,502.8,3.4,441.6,3.4H352.9 c-61.2,0-111.8,46.3-118.601,105.7H284.9C291.3,77.3,319.3,53.4,352.9,53.4z"></path> <path d="M127.2,322.4c71.8,46.4,167.7,72,270.1,72c102.4,0,198.2-25.6,270.101-72C732,280.7,769.5,226.8,774.1,169.7 C756.8,148,730.2,134.1,700.2,134.1H561h-50H283.6h-50H94.4c-29.9,0-56.6,13.9-73.9,35.6C25.1,226.8,62.6,280.6,127.2,322.4z"></path> <path d="M363.1,461.1c0,15.601,12.7,28.3,28.301,28.3H403.1c15.601,0,28.301-12.699,28.301-28.3v-22.6H363.1V461.1L363.1,461.1z"></path> <path d="M94.4,617.201h419.5V553.5c0-7.699,3.1-15,8.6-20.4L618.2,439c5.399-5.3,12.6-8.2,20.1-8.2h156.2V243 c-4.2,8.6-9,17.1-14.5,25.5c-21.5,32.9-52.2,62.3-91,87.4c-60.3,39-135.8,64.4-217.6,74.1v8.399V461 c0,37.701-30.601,68.3-68.301,68.3H391.4c-37.7,0-68.301-30.6-68.301-68.3V438.4V430c-81.8-9.601-157.3-35.101-217.6-74.1 c-38.8-25.1-69.5-54.5-91-87.4C9,260.1,4.2,251.6,0,243v279.8C0,574.9,42.3,617.201,94.4,617.201z"></path> <g> <path d="M659.6,453.6c-13.399,0-26.5,5.5-36,15l-69.1,69.602c-9.5,9.6-14.7,22.199-14.7,35.699v43.301v12.5v12.5V870.9 c0,2.4,0.2,4.801,0.5,7.1c3.4,24.6,24.601,43.6,50.2,43.6h283.8c27.9,0,50.7-22.699,50.7-50.699V504.201 c0-24.5-17.4-44.901-40.5-49.601c-3.3-0.7-6.7-1-10.1-1h-54.9H807h-12.5H659.6L659.6,453.6z M819.5,503.6h54.8 c0.4,0,0.7,0.301,0.7,0.701V871c0,0.1,0,0.1,0,0.201c-0.1,0.299-0.3,0.5-0.6,0.5c0,0,0,0-0.101,0H590.5 c-0.4,0-0.7-0.301-0.7-0.701V642.201v-12.5v-12.5v-33h36.7c22.9,0,41.5-18.602,41.5-41.5V503.6h126.5H807H819.5L819.5,503.6z"></path> <path d="M750,617.301H641.1c-9.199,0-17.199,5-21.6,12.4c-2.2,3.699-3.4,7.898-3.4,12.5v0.1c0,13.799,11.2,25,25,25h182.7 c13.8,0,25-11.201,25-25c0-13.801-11.2-25-25-25h-50.7H750z"></path> <path d="M823.8,774.801H641.1c-13.8,0-25,11.199-25,25c0,13.799,11.2,25,25,25h182.7c13.8,0,25-11.201,25-25 C848.8,786,837.6,774.801,823.8,774.801z"></path> <path d="M823.8,696.1H641.1c-13.8,0-25,11.201-25,25c0,13.801,11.2,25,25,25h182.7c13.8,0,25-11.199,25-25 C848.8,707.301,837.6,696.1,823.8,696.1z"></path> </g> </g> </g> </g></svg>
                                 {props.patients.profession}
                              </Link>}
                              <Link
                                 to="#"
                                 className="btn bgl-primary btn-rounded text-black mb-2 mr-2"
                              >
                                 <svg fill="#229743" viewBox="0 0 28 28" width={24} height={24} xmlns="http://www.w3.org/2000/svg" stroke="#229743" stroke-width="0.00024000000000000003"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M19.73,16.663A3.467,3.467,0,0,0,20.5,14.5a3.5,3.5,0,0,0-7,0,3.467,3.467,0,0,0,.77,2.163A6.04,6.04,0,0,0,12,18.69a6.04,6.04,0,0,0-2.27-2.027A3.467,3.467,0,0,0,10.5,14.5a3.5,3.5,0,0,0-7,0,3.467,3.467,0,0,0,.77,2.163A6,6,0,0,0,1,22a1,1,0,0,0,1,1H22a1,1,0,0,0,1-1A6,6,0,0,0,19.73,16.663ZM7,13a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,7,13ZM3.126,21a4,4,0,0,1,7.748,0ZM17,13a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,17,13Zm-3.874,8a4,4,0,0,1,7.748,0ZM14,1a3.548,3.548,0,0,0-2,.562A3.548,3.548,0,0,0,10,1,3.452,3.452,0,0,0,7.306,2.254a4.135,4.135,0,0,0-.689,3.514c.568,2.762,4.474,4.884,4.918,5.118a1.005,1.005,0,0,0,.93,0c.444-.234,4.35-2.356,4.918-5.117a4.137,4.137,0,0,0-.689-3.515A3.452,3.452,0,0,0,14,1Zm1.425,4.365C15.169,6.6,13.352,8.048,12,8.852c-1.131-.681-3.149-2.139-3.426-3.488a2.172,2.172,0,0,1,.28-1.846A1.46,1.46,0,0,1,10,3a1.349,1.349,0,0,1,1.128.433,1,1,0,0,0,.845.491,1.1,1.1,0,0,0,.88-.463A1.323,1.323,0,0,1,14,3a1.46,1.46,0,0,1,1.145.518A2.174,2.174,0,0,1,15.424,5.365Z"></path></g></svg>
                                 {t('maritalStatus.'+props.patients.maritalSituation)}
                              </Link>
                              <Link
                                 to="#"
                                 className="btn bgl-primary btn-rounded text-black mb-2 mr-2"
                              >
                                 <svg fill="#229743" viewBox="0 0 28 28" width={24} height={24} xmlns="http://www.w3.org/2000/svg" stroke="#229743"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M16.632,14.225a1,1,0,0,1,.143,1.407,6,6,0,0,1-9.55,0,1,1,0,0,1,1.55-1.264,4,4,0,0,0,6.45,0A1,1,0,0,1,16.632,14.225ZM9,12a1,1,0,0,0,1-1V10a1,1,0,0,0-2,0v1A1,1,0,0,0,9,12Zm6,0a1,1,0,0,0,1-1V10a1,1,0,0,0-2,0v1A1,1,0,0,0,15,12Zm8,0A11,11,0,1,1,2.214,7H2A1,1,0,0,1,2,5H3.521A11,11,0,0,1,23,12ZM6.356,5H17.644A8.964,8.964,0,0,0,6.356,5ZM21,12a8.947,8.947,0,0,0-1.522-5H4.522A9,9,0,1,0,21,12Z"></path></g></svg>
                                 {props.patients.childNumber} enfant(s)
                              </Link>
                           </div>
                        </div>
                     </div>
                     <div className="row">
                        <div className="col-lg-6 mb-3">
                           <div className="media">
                              <span className="p-3 border border-primary-light rounded-circle mr-3">
                                 <svg
                                    width={22}
                                    height={22}
                                    viewBox="0 0 32 32"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                 >
                                    <g clipPath="url(#clip0)">
                                       <path
                                          d="M27.5716 13.4285C27.5716 22.4285 16.0001 30.1428 16.0001 30.1428C16.0001 30.1428 4.42871 22.4285 4.42871 13.4285C4.42871 10.3596 5.64784 7.41637 7.8179 5.24631C9.98797 3.07625 12.9312 1.85712 16.0001 1.85712C19.0691 1.85712 22.0123 3.07625 24.1824 5.24631C26.3524 7.41637 27.5716 10.3596 27.5716 13.4285Z"
                                          stroke="#2BC155"
                                          strokeWidth={3}
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                       <path
                                          d="M16.0002 17.2857C18.1305 17.2857 19.8574 15.5588 19.8574 13.4286C19.8574 11.2983 18.1305 9.57141 16.0002 9.57141C13.87 9.57141 12.1431 11.2983 12.1431 13.4286C12.1431 15.5588 13.87 17.2857 16.0002 17.2857Z"
                                          stroke="#2BC155"
                                          strokeWidth={3}
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                       />
                                    </g>
                                    <defs>
                                       <clipPath id="clip0">
                                          <rect
                                             width="30.8571"
                                             height="30.8571"
                                             fill="white"
                                             transform="translate(0.571533 0.571411)"
                                          />
                                       </clipPath>
                                    </defs>
                                 </svg>
                              </span>
                              <div className="media-body">
                                 <span className="d-block text-light mb-2">
                                    Address
                                 </span>
                                 <p className="fs-18 text-dark">
                                    {props.patients.city} - {props.patients.country}
                                 </p>
                              </div>
                           </div>
                        </div>
                        <div className="col-lg-6">
                           <div className="map-bx mb-3">
                              <img src={mapSvg} alt="" width={100}/>

                              <Link
                                 to="#"
                                 className="map-button"
                              >
                                 View in Fullscreen
                              </Link>
                              <Link className="map-marker" to="#">
                                 <i className="las la-map-marker-alt" />
                              </Link>
                           </div>
                        </div>
                        <div className="col-lg-6 mb-md-0 mb-3">
                           <div className="media">
                              <span className="p-3 border border-primary-light rounded-circle mr-3">
                                 <svg
                                    width={22}
                                    height={22}
                                    viewBox="0 0 31 31"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                 >
                                    <path
                                       d="M28.2884 21.7563V25.6138C28.2898 25.9719 28.2165 26.3264 28.073 26.6545C27.9296 26.9826 27.7191 27.2771 27.4553 27.5192C27.1914 27.7613 26.8798 27.9456 26.5406 28.0604C26.2014 28.1751 25.8419 28.2177 25.4853 28.1855C21.5285 27.7555 17.7278 26.4035 14.3885 24.238C11.2817 22.2638 8.64771 19.6297 6.67352 16.523C4.50043 13.1685 3.14808 9.34928 2.72601 5.37477C2.69388 5.0192 2.73614 4.66083 2.8501 4.32248C2.96405 3.98413 3.14721 3.67322 3.38792 3.40953C3.62862 3.14585 3.92159 2.93517 4.24817 2.79092C4.57475 2.64667 4.9278 2.57199 5.28482 2.57166H9.14232C9.76634 2.56552 10.3713 2.78649 10.8445 3.1934C11.3176 3.60031 11.6267 4.16538 11.714 4.78329C11.8768 6.01778 12.1788 7.22988 12.6141 8.39648C12.7871 8.85671 12.8245 9.35689 12.722 9.83775C12.6194 10.3186 12.3812 10.76 12.0354 11.1096L10.4024 12.7426C12.2329 15.9617 14.8983 18.6271 18.1174 20.4576L19.7504 18.8246C20.1001 18.4789 20.5414 18.2406 21.0223 18.1381C21.5031 18.0355 22.0033 18.073 22.4636 18.246C23.6302 18.6813 24.8423 18.9832 26.0767 19.1461C26.7014 19.2342 27.2718 19.5488 27.6796 20.0301C28.0874 20.5113 28.304 21.1257 28.2884 21.7563Z"
                                       stroke="#2BC155"
                                       strokeWidth={3}
                                       strokeLinecap="round"
                                       strokeLinejoin="round"
                                    />
                                 </svg>
                              </span>
                              <div className="media-body">
                                 <span className="d-block text-light mb-2">
                                    {t('common.phone')}
                                 </span>
                                 <p className="fs-18 text-dark font-w600 mb-0">
                                    {props.patients.phoneNumber}
                                 </p>
                              </div>
                           </div>
                        </div>
                        <div className="col-lg-6">
                           <div className="media">
                              <span className="p-3 border border-primary-light rounded-circle mr-3">
                                 <svg
                                    width={22}
                                    height={22}
                                    viewBox="0 0 31 31"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                 >
                                    <path
                                       d="M5.14344 5.14331H25.7168C27.1312 5.14331 28.2884 6.30056 28.2884 7.71498V23.145C28.2884 24.5594 27.1312 25.7166 25.7168 25.7166H5.14344C3.72903 25.7166 2.57178 24.5594 2.57178 23.145V7.71498C2.57178 6.30056 3.72903 5.14331 5.14344 5.14331Z"
                                       stroke="#2BC155"
                                       strokeWidth={3}
                                       strokeLinecap="round"
                                       strokeLinejoin="round"
                                    />
                                    <path
                                       d="M28.2884 7.71503L15.4301 16.7159L2.57178 7.71503"
                                       stroke="#2BC155"
                                       strokeWidth={3}
                                       strokeLinecap="round"
                                       strokeLinejoin="round"
                                    />
                                 </svg>
                              </span>
                              <div className="media-body">
                                 <span className="d-block text-light mb-2">
                                    Email
                                 </span>
                                 <p className="fs-18 text-dark font-w600 mb-0">
                                    {props.patients.email}
                                 </p>
                              </div>
                           </div>
                        </div>
                     </div>
                     
                     {props.patients.healhtParameter && <div className="row">
                        <div className="col-lg-4 mb-3">
                           <div className="media">
                                 <span className="p-2 border border-primary-light rounded-circle mr-3">
                                    <i className="las la-temperature-high text-primary" style={{fontSize: '30px'}}></i>
                                 </span>
                                 <div className="media-body">
                                    <span className="d-block text-primary mb-2">
                                       Température
                                    </span>
                                    <p className="fs-16 text-dark">
                                       <strong>{props.patients.healhtParameter[0]?.temperature}° C</strong>
                                    </p>
                                 </div>
                           </div>
                        </div>
                        <div className="col-lg-4 mb-3">
                           <div className="media">
                                 <span className="p-2 border border-primary-light rounded-circle mr-3">
                                    <i className="las la-text-height text-primary" style={{fontSize: '30px'}}></i>
                                 </span>
                                 <div className="media-body">
                                    <span className="d-block text-primary mb-2">
                                    {t('common.height')}
                                    </span>
                                    <p className="fs-16 text-dark">
                                       <strong>{props.patients.healhtParameter[0]?.height} Cm</strong>
                                    </p>
                                 </div>
                           </div>
                        </div>
                        <div className="col-lg-4 mb-3">
                           <div className="media">
                                 <span className="p-2 border border-primary-light rounded-circle mr-3">
                                    <i className="las la-weight text-primary" style={{fontSize: '30px'}}></i>
                                 </span>
                                 <div className="media-body">
                                    <span className="d-block text-primary mb-2">
                                    {t('common.weight')}
                                    </span>
                                    <p className="fs-16 text-dark">
                                       <strong>{props.patients.healhtParameter[0]?.weight} Kg</strong>
                                    </p>
                                 </div>
                           </div>
                        </div>
                        <div className="col-lg-4 mb-3">
                           <div className="media">
                                 <span className="p-2 border border-primary-light rounded-circle mr-3">
                                    <i className="las la-heartbeat text-primary" style={{fontSize: '30px'}}></i>
                                 </span>
                                 <div className="media-body">
                                    <span className="d-block text-primary mb-2">
                                    {t('client.systolicPressure')}
                                    </span>
                                    <p className="fs-16 text-dark">
                                       <strong>{props.patients.healhtParameter[0]?.bloodpressionS} mmHg</strong>
                                    </p>
                                 </div>
                           </div>
                        </div>
                        <div className="col-lg-4 mb-3">
                           <div className="media">
                                 <span className="p-2 border border-primary-light rounded-circle mr-3">
                                    <i className="las la-heartbeat text-primary" style={{fontSize: '30px'}}></i>
                                 </span>
                                 <div className="media-body">
                                    <span className="d-block text-primary mb-2">
                                    {t('client.diastolicPressure')}
                                    </span>
                                    <p className="fs-16 text-dark">
                                       <strong>{props.patients.healhtParameter[0]?.bloodPressionD} mmHg</strong>
                                    </p>
                                 </div>
                           </div>
                        </div>
                        <div className="col-lg-4 mb-3">
                           <div className="media">
                                 <span className="p-2 border border-primary-light rounded-circle mr-3">
                                    <i className="las la-balance-scale text-primary" style={{fontSize: '30px'}}></i>
                                 </span>
                                 <div className="media-body">
                                    <span className="d-block text-primary mb-2">
                                       IMC
                                    </span>
                                    <p className="fs-16 text-dark">
                                       <strong>{props.patients.healhtParameter[0]?.imc}</strong>
                                    </p>
                                 </div>
                           </div>
                        </div>
                        <div className="col-lg-4 mb-3">
                           <div className="media">
                                 <span className="p-2 border border-primary-light rounded-circle mr-3">
                                    <i className="las la-heart text-primary" style={{fontSize: '30px'}}></i>
                                 </span>
                                 <div className="media-body">
                                    <span className="d-block text-primary mb-2">
                                    {t('consultation.heart-rate')}
                                    </span>
                                    <p className="fs-16 text-dark">
                                       <strong>{props.patients.healhtParameter[0]?.frequenceCard} bmp</strong>
                                    </p>
                                 </div>
                           </div>
                        </div>
                        <div className="col-lg-4 mb-3">
                           <div className="media">
                                 <span className="p-2 border border-primary-light rounded-circle mr-3">
                                    <i className="las la-wind text-primary" style={{fontSize: '30px'}}></i>
                                 </span>
                                 <div className="media-body">
                                    <span className="d-block text-primary mb-2">
                                    {t('consultation.respiratory-rate')}
                                    </span>
                                    <p className="fs-16 text-dark">
                                       <strong>{props.patients.healhtParameter[0]?.frequenceResp} cycle/min</strong>
                                    </p>
                                 </div>
                           </div>
                        </div>
                     </div>}
                  </div>
               </div>
            </div>
            {(hasMenu('MENCONSULT') && canDo('MENCONSULT', 'ACLISTCONSULT')) && <div className="col-xl-3 col-xxl-4 col-md-6">
               <div className="card">
                  <div className="card-header border-0 pb-0">
                     <h4 className="fs-20 font-w600">{t('consultation.consult-history')}</h4>
                  </div>
                  <div className="card-body">
                        <PerfectScrollbar
                                 id="DZ_W_Todo2"
                                 className="widget-timeline-icon2 dz-scroll ps ps--active-y height370"
                              >
                           <ul className="timeline">
                              {props.consultations.map(consultation => {
                              return <li>
                                 <div className="icon bg-primary">
                                    <i className="las la-stethoscope" />
                                 </div>
                                 <Link
                                    className="timeline-panel text-muted"
                                    to={"/consultation-details/"+consultation.id}
                                 >
                                    <h4 className="mb-2 mt-1">{consultation.motif}</h4>
                                    <p className="fs-15 mb-0 ">
                                       {consultation.openDate}
                                    </p>
                                 </Link>
                              </li>})}
                           </ul>
                        </PerfectScrollbar>
                  </div>
               </div>
            </div>}
            <div className="col-lg-12 col-xxl-12 col-md-12">
               <div className="card">
                  <div className="card-header border-0 pb-0">
                     <h4 className="fs-20 font-w600">{t('patient.contract-info')}</h4>
                  </div>
                  <div className="row">
                  <div className="d-flex card-body text-left">
                     <div className="col-lg-6 card-body">
                        <p>{t('patient.policy-number')}: {props.patients.contrat?.police?.numeroPolice}</p>
                        <p>{t('patient.suscriber')}: {props.patients.contrat?.souscripteur?.nom_Assu+' '+props.patients.contrat?.souscripteur?.prenAssu}</p>
                        <p>{t('patient.effective-date')} :  {props.patients.contrat && props.patients.contrat.police && props.patients.contrat.police.dateExpiration ? format(new Date(props.patients.contrat?.police?.dateEffet), 'dd/MM/yyyy') : ""}</p>
                        <p>{t('patient.due-date')} :  {props.patients.contrat && props.patients.contrat.police && props.patients.contrat.police.dateExpiration ? format(new Date(props.patients.contrat?.police?.dateExpiration), 'dd/MM/yyyy') : ""}</p>
                     </div>
                  </div>
                  </div>
               </div>
            </div>

            <div className="col-lg-12 col-xxl-12 col-md-12">
               <div className="card">
                  <div className="card-header">
                     <h4 className="card-title">{t('patient.table-services')}</h4>
                  </div>
                  <PrestationsTab data={props.patients.contrat?.couvertureColleges || []} />
                  {/*{props.patients.contrat && typeof(props.patients.contrat.garanties) !== 'string'  && <div className="card-body">
                     
                        <div>
                           <div className="border-top mt-2 mb-5"></div>
                                 
                           <div className="table-responsive">
                              <div id="job_data" className="dataTables_wrapper ">
                              <table
                                 className="display w-100 dataTable "
                                 id="example5"
                                 role="grid"
                                 aria-describedby="example5_info"
                              >
                                 <thead>
                                       <tr role="row">
                                          <th className="sorting" style={{ width: "177px" }}>
                                             Code garantie
                                          </th>
                                          <th className="sorting" style={{ width: "177px" }}>
                                             Libellé
                                          </th>
                                          <th className="sorting" style={{ width: "46px" }}>
                                             Prime
                                          </th>
                                       </tr>
                                 </thead>

                                 <tbody>
                                 {props.patients.contrat.garanties.map((garanty, k) => {
                                    return <tr className="odd" role="row">
                                       <td>{garanty.code}</td>
                                       <td>{garanty.libelle}</td>
                                       <td>{garanty.primeHt}</td>
                                    </tr>
                                    })
                                 }
                                 </tbody>
                              </table>
                              </div>
                           </div>

                           </div>
                  </div>}*/}
               </div>
            </div>

         </div>}

         {props.patients.from_card && <>
            <div className="row justify-content-center">
               <div className="col-xl-4 col-xxl-6">
                  <div className="card health-card">
                     <div className="card-header" style={{
                        flexDirection: "column",
                        alignItems: "flex-end"
                     }}>
                        <span>{t('common.activa-insurance')}</span>
                        <small style={{fontSize: "13px", fontWeight: "normal"}}>{props.patients.contrat?.police?.numeroPolice+' / '+props.patients.idClient}</small>
                        {/*<small style={{fontSize: "13px", fontWeight: "normal"}}>{props.patients.contrat?.souscripteur?.nom_Assu+' '+props.patients.contrat?.souscripteur?.prenAssu}</small>
                        <small style={{fontSize: "13px", fontWeight: "normal"}}>{t('patient.effective-date')} :  {props.patients.contrat && props.patients.contrat.police && props.patients.contrat.police.dateExpiration ? format(new Date(props.patients.contrat?.police?.dateEffet), 'dd/MM/yyyy') : ""}</small>
                        <small style={{fontSize: "13px", fontWeight: "normal"}}>{t('patient.due-date')} :  {props.patients.contrat && props.patients.contrat.police && props.patients.contrat.police.dateExpiration ? format(new Date(props.patients.contrat?.police?.dateExpiration), 'dd/MM/yyyy') : ""}</small>*/}
                     </div>
                     <div className="card-body" style={{
                        position: "relative",
                     }}>
                        <div className="row px-2 pb-2">
                           <div className="col-5" style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-end"
                           }}>
                              <img
                                 alt=""
                                 className="rounded mr-sm-4 mr-0"
                                 width={130}
                                 style={{
                                    position: "absolute",
                                    top: "-71px",
                                    width: "150px",
                                    height: "150px",
                                    left: "0",
                                    marginBottom: "100px",
                                    border: "#24439D 2px solid"
                                 }}
                                 src={props.patients.clientPhoto || avatarDefault}
                              />
                              <p>{props.patients.city} - {props.patients.country}</p>
                              <p><span>Tel.:</span> {props.patients.phoneNumber}</p>
                              <p><span>Email:</span> {props.patients.email}</p>
                           </div>
                           <div className="col-7">
                              <p><span>{t('common.name')} : </span>{props.patients.firstName+" "+props.patients.lastName}</p>
                              <p><span>{t('common.born-on')} : </span>{format(new Date(props.patients.birthdate), 'dd/MM/yyyy')}</p>
                              <p><span>{t('common.gender')} : </span> {props.patients.sexe === 'M' ? 'Masculin' : 'Feminin'}</p>
                              <p><span>{t('common.job')} : </span> {props.patients.profession}</p>
                              <p><span>{t('client.maritalStatus')} : </span>{t('maritalStatus.'+props.patients.maritalSituation)}</p>
                              <p><span>{t('client.children')} : </span>{props.patients.childNumber} </p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div className="row justify-content-center">
               <div className="col-lg-12 col-xxl-12 col-md-12">
                  <div className="card">
                     <div className="card-header">
                        <h4 className="card-title">{t('patient.table-services')}</h4>
                     </div>
                     <PrestationsTab data={props.patients.contrat?.couvertureColleges || []} />
                     {/*{props.patients.contrat && typeof(props.patients.contrat.garanties) !== 'string'  && <div className="card-body">
                        
                           <div>
                              <div className="border-top mt-2 mb-5"></div>
                                    
                              <div className="table-responsive">
                                 <div id="job_data" className="dataTables_wrapper ">
                                 <table
                                    className="display w-100 dataTable "
                                    id="example5"
                                    role="grid"
                                    aria-describedby="example5_info"
                                 >
                                    <thead>
                                          <tr role="row">
                                             <th className="sorting" style={{ width: "177px" }}>
                                                Code garantie
                                             </th>
                                             <th className="sorting" style={{ width: "177px" }}>
                                                Libellé
                                             </th>
                                             <th className="sorting" style={{ width: "46px" }}>
                                                Prime
                                             </th>
                                          </tr>
                                    </thead>

                                    <tbody>
                                    {props.patients.contrat.garanties.map((garanty, k) => {
                                       return <tr className="odd" role="row">
                                          <td>{garanty.code}</td>
                                          <td>{garanty.libelle}</td>
                                          <td>{garanty.primeHt}</td>
                                       </tr>
                                       })
                                    }
                                    </tbody>
                                 </table>
                                 </div>
                              </div>

                              </div>
                     </div>}*/}
                  </div>
               </div>
            </div>
         </>}
      </>
   );
};

const mapStateToProps = (state) => {
   return {
       patients: state.patient.patient,
       consultations: state.consultation.clientConsultations,
       currentUser: currentUser(state),
   };
};

export default connect(mapStateToProps)(PatientDetails); 

//export default PatientDetails;
